import ServerDetail from './ServerDetail';

export default ServerDetail;
